import { Link } from "react-router-dom";
import { formatNumber, fileUrl } from "@/lib/api";

export default function MessageCard({ m, i = 0 }) {
  return (
    <Link
      to={`/message/${m.id}`}
      className={`block group border oh-hairline bg-[color:var(--oh-bg)] p-8 sm:p-10 transition-colors hover:bg-[color:var(--oh-bg-2)] oh-reveal oh-reveal-d${Math.min(i, 4)}`}
      data-testid={`message-card-${m.id}`}
    >
      <div className="oh-label mb-4 flex items-center justify-between">
        <span>{m.destination_label || (m.destination_type === "everyone" ? "For everyone" : m.destination_type)}</span>
        <span className="text-[color:var(--oh-ink-3)]">{m.origin_country}</span>
      </div>
      {/* Subtle badge — ONLY shown when the backend flags this MESSAGE as
          founding (msg_87923d776e6c). The frontend never hardcodes the id;
          the authoritative `is_founding` flag comes from message_public. */}
      {m.is_founding && (
        <div className="mb-4 -mt-2 oh-label text-[color:var(--oh-blue)]"
             data-testid={`card-founding-${m.id}`}>
          FREE · Founding MESSAGE
        </div>
      )}
      {m.photo_url && (
        <div className="aspect-[16/9] mb-6 overflow-hidden bg-[color:var(--oh-bg-2)] relative">
          <img
            src={fileUrl(m.photo_url)} alt=""
            className="absolute top-1/2 left-1/2 pointer-events-none"
            style={m.photo_position ? {
              transform: `translate(-50%, -50%) translate(${m.photo_position.x}px, ${m.photo_position.y}px) scale(${m.photo_position.scale})`,
              width: "100%", height: "100%", objectFit: "cover",
            } : {
              transform: "translate(-50%, -50%)",
              width: "100%", height: "100%", objectFit: "cover",
            }}
          />
        </div>
      )}
      <h3 className="font-serif-editorial text-3xl sm:text-4xl leading-[1.05] mb-4 text-[color:var(--oh-ink)]">
        {m.title}
      </h3>
      <p className="text-[color:var(--oh-ink-2)] text-base leading-relaxed max-w-lg">
        “{m.text}”
      </p>
      <div className="mt-8 flex items-end justify-between">
        <div>
          <div className="text-4xl sm:text-5xl font-light tabular leading-none">
            {formatNumber(m.voices_count)}
          </div>
          <div className="oh-label mt-2">Voices · {m.countries_count || 0} countries</div>
        </div>
        <div className="oh-label text-[color:var(--oh-red)]"
             data-testid={m.status === "HEARD" ? `card-heard-${m.id}` : `card-cta-${m.id}`}>
          {m.status === "HEARD" ? "Heard ✓" : "Add your voice →"}
        </div>
      </div>
    </Link>
  );
}
